import { BackendModel, BackendService } from '../../core/backend.service';
import { Role } from '../role/role.model';
import { Genero } from './genero.model';
import { Pais } from './pais.model';
import { TipoDocumento } from './tipo-documento.model';
import { Email } from './email.model';
import { MailCredential } from '../security.service';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { Telefono } from './telefono.model';
import { Foto } from './foto.model';
import { Proveedor } from '../../productos/proveedor/proveedor.model';
import { ProveedorSimple } from '../../productos/modificacion-precio/proovedor-simple.model';


export class User extends BackendModel {

  static path = '/usuarios_internos/';

  username: string;
  name: string;
  lastname: string;
  emails: Email[];
  email_direccion: string;
  genero: OperationalParametric;
  habilitado: boolean;
  ultimoLogin: any;
  roles?: Role[];
  password: string;
  retryPassword: string;
  telefonos: Telefono[];
  fotos: Foto[] = [];
  proveedorSimple: ProveedorSimple;
  pais:string;

  constructor(protected backendService: BackendService, model?: User) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/security/user/user.model.ts